/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {decrypt, encrypt} from './crypto.helper';

export function setLocalStorage (key, value) {
    localStorage.setItem(key, value);
}

export function getLocalStorage (key) {
    return localStorage.getItem(key);
}

export function removeLocalStorage (key) {
    return localStorage.removeItem(key);
}

export function setSessionStorage (key, value) {
    const cipherText = encrypt(value);
    return sessionStorage.setItem(key, cipherText);
}

export function getSessionStorage (key) {
    const cipherText = sessionStorage.getItem(key);
    if (cipherText) {
        return decrypt(cipherText);
    }
}

export function removeSessionStorage (key) {
    return sessionStorage.removeItem(key);
}


// WEBPACK FOOTER //
// ./src/_helpers/localStorage.helper.js